import { memo } from 'react';

function Content() {
  return (
    <div>      
      <h1 className="py-16 font-semibold">PLATAFORMA</h1>
      <p>
        Plataforma Tecnológica de Apoio ao Planejamento do Ensino, Avaliação e Prática Docente no Âmbito da EPT
        <footer style={{marginTop: '10px'}}><strong>Edilton</strong></footer>
      </p>
    </div>
  );
}

export default memo(Content);
